import IconButton from '@mui/material/IconButton';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  restore: {
    id: 'autoCuration.pdfSplitEditor.restoreLastRemovedPage',
    defaultMessage: 'Restore last removed page',
  },
});

interface HistoryButtonProps {
  disabled?: boolean;
  onRestorePage: (e: React.MouseEvent) => void;
}

export const HistoryButton = ({
  disabled,
  onRestorePage,
}: HistoryButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <IconButton
      onClick={onRestorePage}
      size="small"
      title={formatMessage(messages.restore)}
      sx={{
        bgcolor: 'white',
        color: (theme) => theme.palette.success.main,
        border: '1.5px solid',
        borderColor: (theme) => theme.palette.success.main,
        borderRadius: '6px',
        width: 28,
        height: 28,
        transition: 'all 0.2s',
        '&:hover': {
          bgcolor: (theme) => theme.palette.success.main,
          color: 'white',
          transform: 'scale(1.08)',
        },
      }}
      disabled={disabled}
    >
      <Icon name="clock-rotate-left" type="fas" style={{ fontSize: 16 }} />
    </IconButton>
  );
};
